/* import __COLOCATED_TEMPLATE__ from './selection-modal-market.hbs.js'; */
var _dec, _dec2, _dec3, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import SelectionModal from '@dashboard/shared-ui/components/modals/selection-modal';
import { computed } from '@ember/object';
let SelectionModalMarket = (_dec = computed('allowDisablingPrimaryButton', 'disableButtonWhenClean', 'disableSaveOnBanner', 'isClean', 'isSaving', 'showSingleBanner'), _dec2 = computed('banners.length', 'options.@each.checked'), _dec3 = computed('shouldShowBanner', 'options.@each.checked'), _class = class SelectionModalMarket extends SelectionModal {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    // passed in
    _defineProperty(this, "ariaLabelId", '');
    _defineProperty(this, "bannerMessage", '');
    _defineProperty(this, "useToggle", false);
    _defineProperty(this, "allowDisablingPrimaryButton", true);
    _defineProperty(this, "disableButtonWhenClean", true);
    _defineProperty(this, "disableSaveOnBanner", false);
    _defineProperty(this, "secondaryButtonLabel", '');
    _defineProperty(this, "bannerVariant", 'warning');
    _defineProperty(this, "banners", []);
    _defineProperty(this, "isSaving", false);
    _defineProperty(this, "shouldShowBanner", () => false);
    _defineProperty(this, "secondaryButtonAction", () => {});
  }
  get disablePrimaryButton() {
    if (!this.allowDisablingPrimaryButton) {
      return false;
    }

    // TODO: Banners should implement their own disableSave method
    if (this.disableSaveOnBanner && this.showSingleBanner) {
      return true;
    }
    if (this.disableButtonWhenClean) {
      return this.isClean;
    }
    return false;
  }
  get bannersToShow() {
    if (this.banners.length > 0) {
      return this.banners.filter(banner => banner.shouldShow(this.options));
    }
    return [];
  }
  get showSingleBanner() {
    return this.shouldShowBanner?.(this.options) ?? false;
  }
}, _applyDecoratedDescriptor(_class.prototype, "disablePrimaryButton", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "disablePrimaryButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bannersToShow", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "bannersToShow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSingleBanner", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "showSingleBanner"), _class.prototype), _class);
export { SelectionModalMarket as default };